module.exports = __webpack_public_path__ + "static/media/Up.4e937837.svg";